import { render, staticRenderFns } from "./ShippingInstructionParty.vue?vue&type=template&id=95ef7804&scoped=true&"
import script from "./ShippingInstructionParty.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructionParty.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructionParty.vue?vue&type=style&index=0&id=95ef7804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef7804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95ef7804')) {
      api.createRecord('95ef7804', component.options)
    } else {
      api.reload('95ef7804', component.options)
    }
    module.hot.accept("./ShippingInstructionParty.vue?vue&type=template&id=95ef7804&scoped=true&", function () {
      api.rerender('95ef7804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/shipping-instruction/ShippingInstructionParty.vue"
export default component.exports